import styled from 'styled-components';
import { media } from '../../../../../theme/shared/breakpoints';
import { LazyImage } from '../../../../components/LazyImage/LazyImage';
import { Link as UnstyledLink } from '../../../../components/Link/Link';
export const FooterContainerFeatured = styled.div `
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;
  margin: 0 -5px;
  gap: 8px;
`;
export const Link = styled(UnstyledLink) `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 80px;
  min-height: 48px;

  ${media.large} {
    max-width: unset;
  }
`;
export const StyledLazyImage = styled(LazyImage) `
  width: 100%;
`;
//# sourceMappingURL=FooterPartners.styled.js.map